import { ApiClient } from "./api";
import { loadConfig, saveConfig } from "./config";
import { startDashboard } from "./app";

/**
 * Arranque del panel con puerta de acceso: sin una API key válida no se monta
 * la operación. La llave se valida una vez contra /v1/operator/fleet.
 */
async function boot(): Promise<void> {
  const gate = document.getElementById("gate");
  const form = document.getElementById("gate-form") as HTMLFormElement | null;
  const keyInput = document.getElementById("gate-key") as HTMLInputElement | null;
  const errorBox = document.getElementById("gate-error");
  const submit = document.getElementById("gate-submit") as HTMLButtonElement | null;

  const showGate = (message?: string): void => {
    if (gate !== null) gate.hidden = false;
    if (errorBox !== null) {
      errorBox.hidden = message === undefined;
      errorBox.textContent = message ?? "";
    }
    keyInput?.focus();
  };
  const hideGate = (): void => {
    if (gate !== null) gate.hidden = true;
  };

  const config = loadConfig();
  if (config.apiKey.trim() !== "") {
    const client = new ApiClient({ baseUrl: config.baseUrl, apiKey: config.apiKey });
    try {
      await client.fleet();
      hideGate();
      startDashboard();
      return;
    } catch (error) {
      showGate(humanizeGateError(error));
    }
  } else {
    showGate();
  }

  form?.addEventListener("submit", (event) => {
    event.preventDefault();
    const candidate = keyInput?.value.trim() ?? "";
    if (candidate === "") {
      showGate("Escribe tu API key.");
      return;
    }
    if (submit !== null) {
      submit.disabled = true;
      submit.textContent = "Verificando…";
    }
    const client = new ApiClient({ baseUrl: config.baseUrl, apiKey: candidate });
    void client
      .fleet()
      .then(() => {
        saveConfig({ ...config, apiKey: candidate });
        hideGate();
        startDashboard();
      })
      .catch((error: unknown) => {
        showGate(humanizeGateError(error));
        if (keyInput !== null) keyInput.value = "";
      })
      .finally(() => {
        if (submit !== null) {
          submit.disabled = false;
          submit.textContent = "Entrar";
        }
      });
  });
}

function humanizeGateError(error: unknown): string {
  if (typeof error === "object" && error !== null) {
    const record = error as { code?: unknown; status?: unknown; message?: unknown };
    const code = typeof record.code === "string" ? record.code : "";
    switch (code) {
      case "operator_key_expired":
        return "Tu acceso venció. Contacta a contacto@rockety.co para renovarlo.";
      case "operator_key_revoked":
        return "Tu acceso fue revocado. Contacta a contacto@rockety.co.";
      case "unauthorized":
        return "La API key no es válida.";
      case "network":
        return "No pudimos conectar con el servicio. Revisa tu conexión e inténtalo de nuevo.";
      default:
        return typeof record.message === "string" && record.message !== ""
          ? record.message
          : "No pudimos validar el acceso.";
    }
  }
  return "No pudimos validar el acceso.";
}

void boot();
